export default "__VITE_ASSET__BgjGVPIl__"